// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"e01c7b24","174":"17910dd5","266":"461ba5c7","582":"1d217078","618":"074c8e03","864":"d2820333","899":"27233774","916":"90fbd00f","923":"331a203d","993":"18425c19"}[chunkId] + ".chunk.js";
};